<script setup lang="ts">
import { computed } from 'vue'

const year = computed(() => new Date().getFullYear())

const domain = computed(() => !import.meta.env.SSR ? document.location.hostname : '')
</script>

<template>
  <div class="bx-print-footer">
    <p>Copyright {{ year }} {{ domain }}. All rights reserved.</p>
  </div>
</template>
